class CartDrawer extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("keyup", (e => e.code === "Escape" && this.close()));
        this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
        this.setHeaderCartIconAccessibility();
        if (new URLSearchParams(window.location.search).get('open-cart') === 'true') {
            window.history.replaceState({}, '', window.location.pathname);
            setTimeout(() => {
                this.open();
                const cartIcon = document.querySelector('#cart-icon-bubble');
                if (cartIcon) cartIcon.setAttribute('aria-pressed', 'true');
            }, 300);
        }
        this.shippingIndicator = this.querySelector(".cart__shipping-indicator");
        this.dismissBtn = this.querySelector("[data-dismiss-indicator]");
        if (this.shippingIndicator && this.dismissBtn) {
            this.setShippingIndicatorVisibility();
            this.addEventListener("click", (e => {
                const t = this.querySelector("[data-dismiss-indicator]");
                if (e.target === t) {
                    this.dismissShippingIndicator()
                }
            }));
            document.addEventListener("cartUpdated", (() => {
                this.setShippingIndicatorVisibility()
            }))
        }
    }

    setHeaderCartIconAccessibility() {
        const e = document.querySelector("#cart-icon-bubble");
        e.setAttribute("role", "button");
        e.setAttribute("aria-haspopup", "dialog");
        e.addEventListener("click", (t => {
            const i = e.getAttribute("aria-pressed");
            t.preventDefault();

            // Show tooltip if cart is empty
            if (this.classList.contains("is-empty")) {
                this.showEmptyCartTooltip();
                return;
            }

            if (i === "false") {
                this.open(e);
                setTimeout((() => {
                    e.setAttribute("aria-pressed", "true")
                }), 10)
            } else {
                this.close()
            }
        }));
        e.addEventListener("keydown", (t => {
            if (t.code.toUpperCase() === "SPACE") {
                t.preventDefault();
                this.open(e)
            }
        }))
    }

    open(e) {
        if (e) this.setActiveElement(e);
        const drawerContainer = this.querySelector(".cart-drawer__main");
        if (drawerContainer) {
            drawerContainer.scrollTop = 0;
        }
        const t = this.querySelector('[id^="Details-"] summary');
        if (t && !t.hasAttribute("role")) this.setSummaryAccessibility(t);
        setTimeout((() => {
            this.classList.add("animate", "active");
            this.setShippingIndicatorVisibility()
        }));
        this.addEventListener("transitionend", (() => {
            const e = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
            const t = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
            trapFocus(e, t)
        }), {once: true});
        setTimeout((() => {
            document.body.classList.add("overflow-hidden")
        }), 10);
        this.header = this.header || document.querySelector(".section-header");
        this.borderOffset = this.borderOffset || document.querySelector(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
        document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().top)}px`);
        const i = new Event("cart-opened");
        window.dispatchEvent(i)
    }

    close() {
        this.classList.add("closing");
        this.classList.remove("active");

        setTimeout((() => {
            this.classList.remove("closing", "animate");
        }), 400);

        removeTrapFocus(this.activeElement);
        document.body.classList.remove("overflow-hidden");
        const e = document.querySelector("#cart-icon-bubble");
        setTimeout((() => {
            e.setAttribute("aria-pressed", "false")
        }), 10)
    }

    setSummaryAccessibility(e) {
        e.setAttribute("role", "button");
        e.setAttribute("aria-expanded", "false");
        if (e.nextElementSibling.getAttribute("id")) {
            e.setAttribute("aria-controls", e.nextElementSibling.id)
        }
        e.addEventListener("click", (e => {
            e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"))
        }));
        e.parentElement.addEventListener("keyup", onKeyUpEscape)
    }

    renderContents(e) {
        this.setShippingIndicatorVisibility();
        this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty");
        this.productId = e.id;
        this.getSectionsToRender().forEach((t => {
            const i = t.selector ? document.querySelector(t.selector) : document.getElementById(t.id);
            i.innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector)
        }));
        if (window.Nosto) {
            Nosto.reloadCart(["nosto-minicart"])
        }

        setTimeout((() => {
            this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
            // Disabled auto-open - using success message instead
        }))
    }

    getSectionInnerHTML(e, t = ".shopify-section") {
        const i = (new DOMParser).parseFromString(e, "text/html").querySelector(t).innerHTML;
        return i
    }

    getSectionsToRender() {
        return [{id: "cart-drawer", selector: "#CartDrawer"}, {id: "cart-icon-bubble"}]
    }

    getSectionDOM(e, t = ".shopify-section") {
        return (new DOMParser).parseFromString(e, "text/html").querySelector(t)
    }

    setActiveElement(e) {
        this.activeElement = e
    }

    dismissShippingIndicator() {
        this.shippingIndicator = this.querySelector(".cart__shipping-indicator");
        this.dismissBtn = this.querySelector("[data-dismiss-indicator]");
        this.shippingIndicator.classList.add("is-dismissed");
        this.shippingIndicator.classList.remove("is-shown");
        sessionStorage.setItem("shipping-indicator-dismissed", true)
    }

    setShippingIndicatorVisibility() {
        this.shippingIndicator = this.querySelector(".cart__shipping-indicator");
        if (!this.shippingIndicator) return;
        this.checkDismissed = sessionStorage.getItem("shipping-indicator-dismissed");
        if (this.checkDismissed == "true") {
            this.shippingIndicator.classList.add("is-dismissed");
            this.shippingIndicator.classList.remove("is-shown")
        } else {
            this.shippingIndicator.classList.add("is-shown")
        }
    }

    showEmptyCartTooltip() {
        // Remove existing tooltip if any
        const existing = document.querySelector(".cart-empty-tooltip");
        if (existing) {
            existing.remove();
            return;
        }

        // Create tooltip
        const tooltip = document.createElement("div");
        tooltip.className = "cart-empty-tooltip";
        tooltip.innerHTML = `
            <button type="button" class="cart-empty-tooltip__close global-drawer__close" style="position: absolute; top: 0; right: 0;" aria-label="Close">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.05365 16.6731L7.3269 15.9463L11.2729 12.0001L7.3269 8.0788L8.05365 7.35205L11.9999 11.2981L15.9212 7.35205L16.6479 8.0788L12.7019 12.0001L16.6479 15.9463L15.9212 16.6731L11.9999 12.7271L8.05365 16.6731Z" fill="black"/></svg>
            </button>
            <span class="F3-Reg-LC" style="width: 100%;">Your cart is empty</span>
        `;

        // Position near cart icon
        const cartIcon = document.querySelector("#cart-icon-bubble");
        const rect = cartIcon.getBoundingClientRect();
        tooltip.style.cssText = `
            position: fixed;
            top: 0px;
            right: 0px;
            max-width: 400px;
            width: 100%;
            background: var(--Surface-Surface-Blur, rgba(255, 255, 255, 0.95));
            box-shadow: 0 4px 4px 0 rgba(187, 187, 187, 0.15);
            backdrop-filter: blur(15px);
            border: 1px solid #e5e5e5;
            padding: 36px 12px 24px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            z-index: 9999;
            display: flex;
            text-align:center;
        `;

        document.body.appendChild(tooltip);

        // Close button handler
        tooltip.querySelector(".cart-empty-tooltip__close").addEventListener("click", () => {
            tooltip.remove();
        });
    }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [{id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner"}, {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section"
        }]
    }
}

customElements.define("cart-drawer-items", CartDrawerItems);
